import React, { FC } from 'react';
import classNames from 'classnames';
import { CardSection } from './CardSection';
import { CardSectionProps } from '.';

interface CardContentProps extends CardSectionProps {
  className?: string;
}

export const CardContent: FC<CardContentProps> = ({ className, ...props }) => (
  <CardSection className={classNames('card__content flex-grow', className)} {...props} />
);
